"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PRIMARY: 'primary',
  WHITE: 'white',
  RED: 'red'
};
exports.default = _default;